import React, { useEffect, useState } from 'react';

import DatePicker from 'react-datepicker';

import { useField } from 'formik';
import moment from 'moment';

import classNames from 'classnames';

import './index.scss';

const RANGE_VALUES = {
  DAYS: 'days',
  DATE: 'date',
};

const MutateTaskDate = ({ name, ...props }) => {
  const [dueDateField, , dueDateFieldHelpers] = useField(`${name}.dueDate`);
  const [dueDateLengthField, , dueDateLengthFieldHelpers] = useField(
    `${name}.dueDateLength`,
  );

  const [date, setDate] = useState(
    new Date(moment(dueDateField.value || undefined).toISOString(true)),
  );
  const [range, setRange] = useState(
    dueDateField.value ? RANGE_VALUES.DATE : RANGE_VALUES.DAYS,
  );
  const [datePickerToggled, setDatePickerToggled] = useState(false);

  useEffect(() => {
    if (range === RANGE_VALUES.DATE) {
      dueDateFieldHelpers.setValue(date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, range]);

  useEffect(() => {
    if (range === RANGE_VALUES.DAYS) {
      dueDateFieldHelpers.setValue('');
    }
    if (range === RANGE_VALUES.DATE) {
      dueDateLengthFieldHelpers.setValue('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range]);

  useEffect(() => {
    if (dueDateLengthField.value < 1) {
      dueDateLengthFieldHelpers.setValue('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dueDateLengthField.value]);

  return (
    <>
      <div className="range-switcher">
        <div
          className={`range-button ${
            range === RANGE_VALUES.DAYS ? 'checked' : ''
          }`}
          onClick={() => setRange(RANGE_VALUES.DAYS)}
        >
          <span>Task duration(days)</span>
        </div>
        <div
          className={`range-button ${
            range === RANGE_VALUES.DATE ? 'checked' : ''
          }`}
          onClick={() => setRange(RANGE_VALUES.DATE)}
        >
          <span>Task date</span>
        </div>
      </div>
      {range === RANGE_VALUES.DAYS && (
        <input
          type="number"
          {...dueDateLengthField}
          className={classNames(
            'mutate-task-date',
            // eslint-disable-next-line react/destructuring-assignment
            props.className,
          )}
          placeholder="Due date length in days"
        />
      )}
      {range === RANGE_VALUES.DATE && (
        <div className="mutate-task-date">
          <span
            onClick={() => setDatePickerToggled(!datePickerToggled)}
            placeholder="Due date"
          >
            {moment(dueDateField.value || undefined).format('DD.MM.Y')}
          </span>
          {datePickerToggled && (
            <DatePicker
              inline
              selected={date}
              name={`${name}.dueDate`}
              onChange={(value) => {
                setDate(new Date(moment(value).toISOString(true)));
                setDatePickerToggled(false);
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default MutateTaskDate;
